import { render, staticRenderFns } from "./TransferOtherAccount.vue?vue&type=template&id=57c354bd"
import script from "./TransferOtherAccount.vue?vue&type=script&lang=js"
export * from "./TransferOtherAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports